 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"chunk-01cd33ce":"42555775","chunk-03499942":"28ce8ffa","chunk-085177e3":"81c62064","chunk-08824095":"99e30288","chunk-0bf9523c":"d80d542e","chunk-189fe358":"2977e796","chunk-1f8268ae":"84744d2f","chunk-20f1c25b":"61db844a","chunk-2303f0ff":"d446cfdd","chunk-2797aa70":"c22f2b5d","chunk-2c5d2cfb":"9d3a1fe6","chunk-2d0f012d":"733a555d","chunk-2d9b5c68":"1e96364f","chunk-17d5fccc":"f7799b42","chunk-2d28cd9b":"fcfc1732","chunk-44eb21bd":"17595f97","chunk-50dca7ec":"bfa8f5fd","chunk-808a7e6e":"0202445c","chunk-2e46f772":"28fcd8be","chunk-367ba893":"927d2824","chunk-38c82c20":"4b1bc7db","chunk-1693b541":"7af7c5a2","chunk-51536b2d":"5109780c","chunk-6e62fa0d":"ca5c4d2f","chunk-6ee3ee64":"5aaddfd6","chunk-7525c542":"1f199447","chunk-d468a41c":"520877bb","chunk-e07c22e0":"d88cbc9e","chunk-1f31b311":"e8808a4d","chunk-4a03185c":"1364e07b","chunk-e1903e7c":"9028835b","chunk-41eeccc0":"f228f61e","chunk-46573a16":"5e2f9f66","chunk-4b6e8d48":"2eebe4c7","chunk-4c030dcc":"5190ea2d","chunk-4dfe4712":"53dde6a1","chunk-4e12a4a1":"2c616f8d","chunk-50d749b2":"82c23297","chunk-211f16c9":"0167cf59","chunk-757323e8":"a1ee669d","chunk-528266d9":"8245660e","chunk-5996ca5a":"b3674feb","chunk-5af372f2":"b124e3e3","chunk-5ddfb7f3":"2b6c909e","chunk-5ed0ebfe":"72f71603","chunk-5f6a7887":"63ecc97a","chunk-5fbb1852":"0f3b8299","chunk-61b4409c":"90b1a65b","chunk-61f60e1c":"046003d0","chunk-653ff353":"d0913ef2","chunk-7273946b":"0e435b2f","chunk-773af30f":"6bbd7ff1","chunk-785dcd39":"dd5fcb99","chunk-7a446a84":"9083708f","chunk-7bbaf9c4":"446768d7","chunk-7c83252f":"5729703d","chunk-7ce80036":"1f37e0a4","chunk-848cca48":"3d7be7f2","chunk-84fbb32e":"80b501c3","chunk-8a3567fe":"962f31e8","chunk-8bba2092":"929914e8","chunk-00909568":"1caed63d","chunk-6d3eab5a":"de1efc32","chunk-8ceb396c":"15759c23","chunk-9092859e":"95500902","chunk-95810866":"425676e6","chunk-9828293c":"9ff5683e","chunk-98577534":"c10681fe","chunk-9e25f36a":"45b16394","chunk-a4883de8":"bd7841a4","chunk-aaa35bd2":"ee0f98e1","chunk-b019baf4":"a3228c88","chunk-bcf151d2":"4995b935","chunk-c2d7025a":"3d919d5f","chunk-c354124e":"446bd6a7","chunk-c7cc4e22":"4b123801","chunk-cb986658":"49363da8","chunk-d09e1d52":"ac634a97","chunk-d23119fa":"89df17a4","chunk-e2cd2064":"0dae3ecc","chunk-e40640be":"0f839c3b","chunk-ef639c14":"6132f1fc","chunk-27d757c9":"3327da0a","chunk-380b32bc":"d9f03731","chunk-2259c1ea":"2ae7e77f","chunk-743f4005":"f696832c","chunk-e36df4c6":"bf750acb","chunk-48ba33d1":"6aa141e1","chunk-7dbfedb9":"a07242a0","chunk-fe7a4c16":"2926d837","chunk-ff62323a":"ff0a5e81"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01cd33ce":1,"chunk-03499942":1,"chunk-085177e3":1,"chunk-08824095":1,"chunk-0bf9523c":1,"chunk-189fe358":1,"chunk-1f8268ae":1,"chunk-20f1c25b":1,"chunk-2303f0ff":1,"chunk-2797aa70":1,"chunk-2c5d2cfb":1,"chunk-2d9b5c68":1,"chunk-17d5fccc":1,"chunk-2d28cd9b":1,"chunk-44eb21bd":1,"chunk-50dca7ec":1,"chunk-808a7e6e":1,"chunk-2e46f772":1,"chunk-367ba893":1,"chunk-1693b541":1,"chunk-51536b2d":1,"chunk-6e62fa0d":1,"chunk-6ee3ee64":1,"chunk-7525c542":1,"chunk-d468a41c":1,"chunk-e07c22e0":1,"chunk-1f31b311":1,"chunk-4a03185c":1,"chunk-e1903e7c":1,"chunk-41eeccc0":1,"chunk-46573a16":1,"chunk-4b6e8d48":1,"chunk-4c030dcc":1,"chunk-4dfe4712":1,"chunk-4e12a4a1":1,"chunk-50d749b2":1,"chunk-211f16c9":1,"chunk-757323e8":1,"chunk-528266d9":1,"chunk-5996ca5a":1,"chunk-5af372f2":1,"chunk-5ddfb7f3":1,"chunk-5ed0ebfe":1,"chunk-5f6a7887":1,"chunk-5fbb1852":1,"chunk-61b4409c":1,"chunk-61f60e1c":1,"chunk-653ff353":1,"chunk-7273946b":1,"chunk-773af30f":1,"chunk-785dcd39":1,"chunk-7a446a84":1,"chunk-7bbaf9c4":1,"chunk-7c83252f":1,"chunk-7ce80036":1,"chunk-848cca48":1,"chunk-84fbb32e":1,"chunk-8a3567fe":1,"chunk-8bba2092":1,"chunk-00909568":1,"chunk-6d3eab5a":1,"chunk-8ceb396c":1,"chunk-9092859e":1,"chunk-95810866":1,"chunk-9828293c":1,"chunk-98577534":1,"chunk-9e25f36a":1,"chunk-a4883de8":1,"chunk-aaa35bd2":1,"chunk-b019baf4":1,"chunk-bcf151d2":1,"chunk-c2d7025a":1,"chunk-c354124e":1,"chunk-c7cc4e22":1,"chunk-cb986658":1,"chunk-d09e1d52":1,"chunk-d23119fa":1,"chunk-e2cd2064":1,"chunk-e40640be":1,"chunk-ef639c14":1,"chunk-27d757c9":1,"chunk-380b32bc":1,"chunk-2259c1ea":1,"chunk-743f4005":1,"chunk-e36df4c6":1,"chunk-48ba33d1":1,"chunk-7dbfedb9":1,"chunk-fe7a4c16":1,"chunk-ff62323a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01cd33ce":"a286755a","chunk-03499942":"b8511433","chunk-085177e3":"e7d31340","chunk-08824095":"18663377","chunk-0bf9523c":"a333fc62","chunk-189fe358":"fd40c88f","chunk-1f8268ae":"1f38ebaa","chunk-20f1c25b":"9b09070b","chunk-2303f0ff":"53db732b","chunk-2797aa70":"29d561c2","chunk-2c5d2cfb":"42e79682","chunk-2d0f012d":"31d6cfe0","chunk-2d9b5c68":"22cb0a68","chunk-17d5fccc":"9dadacdd","chunk-2d28cd9b":"3bb8c339","chunk-44eb21bd":"73968b4e","chunk-50dca7ec":"e5e531f0","chunk-808a7e6e":"0a536141","chunk-2e46f772":"d86f7dec","chunk-367ba893":"9d6aa588","chunk-38c82c20":"31d6cfe0","chunk-1693b541":"84d50754","chunk-51536b2d":"9ddb06e2","chunk-6e62fa0d":"55ffb90d","chunk-6ee3ee64":"29423f97","chunk-7525c542":"99b513d3","chunk-d468a41c":"746925a7","chunk-e07c22e0":"921e11cb","chunk-1f31b311":"eacfbbd0","chunk-4a03185c":"13368fb5","chunk-e1903e7c":"0c5dbcf1","chunk-41eeccc0":"7924b2c0","chunk-46573a16":"4f0f0a33","chunk-4b6e8d48":"42c0c2e4","chunk-4c030dcc":"fadb74c1","chunk-4dfe4712":"4f6bb632","chunk-4e12a4a1":"dc7bea51","chunk-50d749b2":"4cfd01a8","chunk-211f16c9":"3027738b","chunk-757323e8":"3c23ecf6","chunk-528266d9":"f10c23ae","chunk-5996ca5a":"31e87ec4","chunk-5af372f2":"928b2673","chunk-5ddfb7f3":"13ab85fb","chunk-5ed0ebfe":"339037df","chunk-5f6a7887":"b96b7c0d","chunk-5fbb1852":"f5dd4cf2","chunk-61b4409c":"85529b50","chunk-61f60e1c":"2e53498a","chunk-653ff353":"4402f4d6","chunk-7273946b":"094d8ac9","chunk-773af30f":"cc237e08","chunk-785dcd39":"e01d5ff0","chunk-7a446a84":"03352711","chunk-7bbaf9c4":"d37bf486","chunk-7c83252f":"dd51412e","chunk-7ce80036":"f5fddec4","chunk-848cca48":"16f07819","chunk-84fbb32e":"e1955faa","chunk-8a3567fe":"5f052f8b","chunk-8bba2092":"626fa483","chunk-00909568":"13ba3d1d","chunk-6d3eab5a":"e8e4282f","chunk-8ceb396c":"78b85c4c","chunk-9092859e":"23414bf9","chunk-95810866":"bb707cf9","chunk-9828293c":"6f4c1d59","chunk-98577534":"86f25d78","chunk-9e25f36a":"cd40cd8d","chunk-a4883de8":"c8398ebe","chunk-aaa35bd2":"3582db58","chunk-b019baf4":"bf099361","chunk-bcf151d2":"e50494b0","chunk-c2d7025a":"a0f3e0f2","chunk-c354124e":"212c8d2e","chunk-c7cc4e22":"47d289bc","chunk-cb986658":"e2575994","chunk-d09e1d52":"afb1b291","chunk-d23119fa":"b6b074b6","chunk-e2cd2064":"acd5a3be","chunk-e40640be":"72542d3a","chunk-ef639c14":"128ce4d2","chunk-27d757c9":"c34a8b49","chunk-380b32bc":"b57c9d60","chunk-2259c1ea":"31e41041","chunk-743f4005":"28282d63","chunk-e36df4c6":"8f3990f1","chunk-48ba33d1":"c7174882","chunk-7dbfedb9":"fce5d5a2","chunk-fe7a4c16":"8c2b0e9b","chunk-ff62323a":"43b17860"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_stu-health"] = window["webpackJsonp_stu-health"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
